import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'
import FormattedInputField from '../../sharedComponents/formattedInputField.component.jsx'

class CommitmentDurationInput extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            value: this.props.value || '',
            name: this.props.name || '',
            className: this.props.className || '',
            billingMethod: this.props.billingMethod || '',
        }

        const defaultCallback = () => {}
        this.onChange = this.props.onChange || defaultCallback
        this.handleFocus = this.handleFocus.bind(this)
    }


    handleFocus(event) {
        event.target.select()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            name: nextProps.name || '',
            value: nextProps.value || '',
            billingMethod: nextProps.billingMethod || '',
        })
    }

    renderUnit() {
        switch (this.state.billingMethod) {
            case "monthly":
                return <FormattedMessage
                    id="common.billing_method.input.month_label_long"
                    defaultMessage="{measure, plural, one {month} other {months}}"
                    values={{
                        measure: this.state.value
                    }}
                />
            case "yearly":
                return <FormattedMessage
                    id="common.billing_method.input.year_label_long"
                    defaultMessage="{measure, plural, one {year} other {years}}"
                    values={{
                        measure: this.state.value
                    }}
                />
        }
    }

    render() {
        if (!this.state.billingMethod || this.state.billingMethod === 'one-time') {
            return <div />
        }
        return <div className={"input-group "+ this.state.className}>
            <FormattedInputField
                name={this.state.name}
                id={this.state.name}
                type="text"
                className={"form-control " }
                placeholder={"0"}
                valueType="decimal"
                allowNegative={false}
                decimalScale={0}
                value={this.state.value}
                onValueChange={(newValue) => { this.setState({ measure: newValue }, () => { this.onChange(newValue) }) }}
                onFocus={this.handleFocus}
                onClick={this.handleFocus}
            />
            <div className="input-group-append">
                <span className="input-group-text" id="basic-addon2">{this.renderUnit()}</span>
            </div>
        </div>
    }
}

export default CommitmentDurationInput





// WEBPACK FOOTER //
// ./src/common/pricing/commitmentdurationinput.component.jsx